__turbopack_context__.v({
  "closeButton": "AW2r5W_closeButton",
  "container": "AW2r5W_container",
  "head": "AW2r5W_head",
  "loading": "AW2r5W_loading",
  "meta": "AW2r5W_meta",
  "modal": "AW2r5W_modal",
  "page": "AW2r5W_page",
  "pageInner": "AW2r5W_pageInner",
  "title": "AW2r5W_title",
});
